function getGraphId(title: string) {
	return `graph-${title.toLowerCase().replaceAll(' ', '-')}`;
}

export default getGraphId;
